module.exports = __webpack_public_path__ + "img/touxiang.7df14242.png";